import localeCore from './locale';
import {
	saveSettings,
	getAllSettings,
	syncGlobalAddresses,
	syncOrderTypes,
	syncIncoterms,
	syncDrivers,
	syncCargoCarriers,
	syncGoodsTypes,
	syncPackageTypes,
	syncTripTypes,
	syncCustomers,
	deleteModuleData,
	syncCargoCarrierTypes
} from '../requests';

function saveGeneralSettings({ commit }, { language }) {
	localeCore.set(language.locale);
	commit('setLocale', language.locale);
}

async function deleteModule({}, moduleName) {
	await deleteModuleData(moduleName);
}

async function syncModule({}, moduleName) {
	switch (moduleName) {
	case 'globalAddresses':
		await syncGlobalAddresses();
		break;
	case 'orderTypes':
		await syncOrderTypes();
		break;
	case 'incoterms':
		await syncIncoterms();
		break;
	case 'drivers':
		await syncDrivers();
		break;
	case 'cargoCarriers':
		await syncCargoCarriers();
		break;
	case 'cargoCarrierTypes':
		await syncCargoCarrierTypes();
		break;
	case 'goodsTypes':
		await syncGoodsTypes();
		break;
	case 'packageTypes':
		await syncPackageTypes();
		break;
	case 'tripTypes':
		await syncTripTypes();
		break;
	case 'customers':
		await syncCustomers();
		break;
	default:
		throw new Error(`Module with name ${  moduleName  } not found.`);
	}
}

async function getSettings({ commit }) {
	commit('setLoading', { key: 'allAvailableSettings', isLoading: true });

	let settings = await getAllSettings();

	commit('setLoading', { key: 'allAvailableSettings', isLoading: false });

	commit('setSettings', settings);
}

function markParameterAsChanged({ commit }, { parameter, changed }) {
	commit('setParameterChanged', { parameter, changed });
}

async function saveSystemSettings({ commit, state }) {
	let changedParameters = state.allAvailableSettings.filter(x => x.changed === true);
	await saveSettings(changedParameters);
	if (changedParameters.lenght === 0)
		return '';

	let changed = changedParameters.map(x => x.id).join(', ');
	commit('setParametersAsUnchanged', { parameters: changedParameters });
	return { changed: changed, parameters: changedParameters };
}

export default { saveGeneralSettings, syncModule, getSettings, markParameterAsChanged, saveSystemSettings, deleteModule };